<template>
    <div class="profile">
        <div>
            <div class="img">
                <input type="file" ref="select_file_profile" name="photo" @change="profileUpdatePhoto" class="register-file" accept="image/gif, image/jpeg, image/jpg, image/png, image/bmp" />
                <img :src="image" alt="" @click="$refs.select_file_profile.click()">
                <label for="">Studio: </label>
                <h2 for="">{{ studio_name }}</h2>
            </div>
            <div class="info">
                <center><h2>Información</h2></center>
                <div>
                    <label for="">Nombre: </label>
                    <input type="text" v-model="name">
                </div>
                <div>
                    <label for="">apellido: </label>
                    <input type="text" v-model="apellido">
                </div>
                <div>
                    <label for="">Sede: </label>
                    <input type="text" v-model="sede">
                </div>
                <div>
                    <label for="">Ceular: </label>
                    <vue-tel-input v-model.lazy="phone" onpaste="return false;"
                        @keypress.native="checkPhoneNumber" :preferredCountries="['co']" v-bind:placeholder="'phone'">
                    </vue-tel-input>
                </div>
                <div>
                    <label for="">Pais: </label>
                    <b-form-select v-model="country">
                        <option v-for="(elem, index) in countries" :key="index" :value="elem">{{ elem }}</option>
                    </b-form-select>
                </div>
                <div>
                    <label for="">Fecha de nacimiento: </label>
                    <input type="date" v-model="date_of_birth">
                </div>
                <div>
                    <label for="">Sexo: </label>
                    <toggle-button
                        v-model="sex"
                        class="toggle"
                        color="#82C7EB"
                        :sync="true"
                        :width="250"
                        :height="40"
                        :labels="{checked: 'MUJER', unchecked: 'HOMBRE'}"/>
                </div>
                <div>
                    <label for="">Ciudad: </label>
                    <input type="text" v-model="location">
                </div>
                <div>
                    <label for="">Email: </label>
                    <input type="text" v-model="email">
                </div>
                <div>
                    <label for="">Tipo de usuario: </label>
                    <h5>{{user_type}}</h5>
                </div>
                <center><button @click="changeInfo">Actualizar</button></center>
            </div>
        </div>
        <div>
            <div class="permission">
                <center><h2>Permisos</h2></center>
                <div>
                    <div>
                        <label for="">Permiso administrativo</label>
                        <img src="@/assets/ok.png" alt="" v-if="admin">
                        <img src="@/assets/error.png" alt="" v-if="!admin">
                    </div>
                    <div>
                        <label for="">Permiso soporte</label>
                        <img src="@/assets/ok.png" alt="" v-if="support">
                        <img src="@/assets/error.png" alt="" v-if="!support">
                    </div>
                </div>
               <div>
                    <div>
                        <label for="">Permiso contador</label>
                        <img src="@/assets/ok.png" alt="" v-if="counter">
                        <img src="@/assets/error.png" alt="" v-if="!counter">
                    </div>
                    <div>
                        <label for="">Permiso recepcionista</label>
                        <img src="@/assets/ok.png" alt="" v-if="receptionist">
                        <img src="@/assets/error.png" alt="" v-if="!receptionist">
                    </div>
               </div>
            </div>
            <div class="password">
                <center><h2>Cambiar contraseña</h2></center>
                <div>
                    <label for="">Escribe la nueva contraseña</label>
                    <input type="password"
                        v-model.trim="$v.passValue.$model"
                        :class="status($v.passValue, passFlag)"
                        @focus="passFlag = true"
                        @blur="passFlag = false">
                </div>
                <div v-if="!$v.passValue.goodPassword" class="error-mess">La contraseña debe tener minimo un numero y una MAYUSCULA</div>
                <div>
                    <label for="">Escribe la contraseña nuevamente</label>
                    <input type="password"
                        v-model.trim="$v.repeatPassword.$model"
                        :class="status($v.repeatPassword, passFlag)"
                        @focus="repeatpassFlag = true"
                        @blur="repeatpassFlag = false">
                </div>
                <div v-if="!$v.repeatPassword.sameAsPassword" class="error-mess">Las contraseñas no son iguales</div>
                <center><button @click="changePassword">Actualizar</button></center>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import RockerSwitch from 'vue-rocker-switch'
import { ToggleButton } from 'vue-js-toggle-button'
import Notify from '@/utils/Notification.js'
import { sameAs, required, minLength } from 'vuelidate/lib/validators'

export default {
    name: 'profile',
    components: {
        RockerSwitch,
        ToggleButton
    },
    validations: {
        passValue: {
            required,
            minLength: minLength(8),
            goodPassword: (password) => {
                if (password === '') {
                    return true
                } else {
                    return /[a-z]/.test(password) &&
                    /[A-Z]/.test(password) &&
                    /[0-9]/.test(password)
                }
            }
        },
        repeatPassword: {
            sameAsPassword: sameAs('passValue')
        }
    },
    data() {
        return {
            name: null,
            apellido: null,
            admin: null,
            support: null,
            counter: null,
            receptionist: null,
            image: null,
            sede: null,
            phone: null,
            country: null,
            date_of_birth: null,
            sex: null,
            location: null,
            email: null,
            user_type: null,
            studio_name: null,
            profilePicture: null,
            productsPictureObject: null,
            apis: null,
            countries: [],
            passValue: null,
            repeatPassword: null,
            passFlag: false,
            repeatpassFlag: false
        }
    },
    methods: {
        changePassword() {
            if (this.passValue !== this.repeatPassword) {
                return
            }
            API.changePasswordAdmin(this.passValue)
                .then(() => {
                    Notify('dirty', 'Se cambio la contraseña con exito')
                })
        },
        profileUpdatePhoto (picture) {
            var file = picture.target.files || picture.dataTransfer.files
            if (!file.length) {
                return
            }

            this.saveImage(file[0], () => {
                API.profileAdminPictureUpdate(this.productsPictureObject)
                    .then(result => {
                        Notify('dirty', 'Se cambio la imagen de perfil con exito')
                        this.getAdminInfo()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            })
        },
        saveImage (file, cb) {
            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
                if (file.type === 'image/gif') {
                    vm.profilePicture = e.target.result
                    vm.productsPictureObject = file
                    if (cb) {
                        var toSend = {}
                        toSend.src = vm.profilePicture
                        cb(toSend)
                    }
                } else {
                    var image = new Image()
                    image.src = e.target.result
                    var width = 0
                    var height = 0
                    image.onload = function() {
                        width = this.width
                        height = this.height
                        var canvas = document.createElement('canvas')
                        var ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0)
                        var maxWidth = 400
                        var maxHeight = 400
                        if (width > height) {
                            if (width > maxWidth) {
                                height *= maxWidth / width
                                width = maxWidth
                            }
                        } else {
                            if (height > maxHeight) {
                                width *= maxHeight / height
                                height = maxHeight
                            }
                        }
                        canvas.width = width
                        canvas.height = height
                        ctx = canvas.getContext('2d')
                        ctx.drawImage(image, 0, 0, width, height)
                        vm.profilePicture = canvas.toDataURL(file.type)
                        var byteString
                        if (vm.profilePicture.split(',')[0].indexOf('base64') >= 0) {
                            byteString = atob(vm.profilePicture.split(',')[1])
                        } else {
                            byteString = unescape(vm.profilePicture.split(',')[1])
                        }
                        var mimeString = vm.profilePicture.split(',')[0].split(':')[1].split(';')[0]
                        var ia = new Uint8Array(byteString.length)
                        for (var i = 0; i < byteString.length; i++) {
                            ia[i] = byteString.charCodeAt(i)
                        }
                        try {
                            vm.productsPictureObject = new File([new Blob([ia], {type: mimeString})], file.type)
                        } catch (err) {
                            vm.productsPictureObject = new Blob([ia], {type: mimeString})
                            vm.productsPictureObject.name = file.name
                            vm.productsPictureObject.lastModifiedDate = new Date()
                        }

                        if (cb) {
                            cb(image)
                        }
                    }
                }
            }
            reader.readAsDataURL(file)
        },
        status(validation, flag) {
            if (!flag) {
                return {
                    error: validation.$error,
                    dirty: validation.$dirty
                }
            }
        },
        changeInfo() {
            var info = {
                name: this.name,
                last_name: this.apellido,
                phone: this.phone,
                country: this.country,
                date_of_birth: this.date_of_birth,
                sex: this.sex,
                location: this.location,
                email: this.email
            }
            API.changeAdminProfile(info)
                .then(() => {
                    Notify('dirty', 'Se cambio la informacion de perfil con exito')
                    this.getAdminInfo()
                })
        },
        getCountriesList: function() {
            this.$http.get('https://restcountries.com/v3.1/all').then(function(response) {
                var contries = []
                response.body.forEach(country => {
                    if (country.name.common === 'Tanzania') {
                        return
                    }
                    contries.push(country.name.common)
                })
                this.countries = contries.sort()
            })
        },
        getAdminInfo() {
            API.getAdminInfo()
                .then((res) => {
                    this.name = res.name
                    this.apellido = res.apellido
                    this.admin = res.admin === 1
                    this.support = res.support === 1
                    this.counter = res.counter === 1
                    this.receptionist = res.receptionist === 1
                    this.image = res.image
                    this.sede = res.sede
                    this.phone = res.phone
                    this.country = res.country
                    this.date_of_birth = res.date_of_birth ? res.date_of_birth.split(this.$store.state.constants.SEPARETOR)[0] : null
                    this.sex = res.sex === 'F'
                    this.location = res.location
                    this.email = res.email
                    this.user_type = res.user_type
                    this.studio_name = res.studio_name
                    this.apis = res.apis
                })
        }
    },
    mounted() {
        this.getAdminInfo()
        this.getCountriesList()
    }
}
</script>

<style scoped>
    .profile{
        background-color: #cdcdcd;
        height: 90vh;
        display: flex
    }
    .profile > div {
        width: 100%;
        padding: 20px;
        height: 100%;
    }
    .profile > div > .img {
        background-color: #8363b7;
        width: 100%;
        height: 25%;
        position: relative;
        border-radius: 20px;
        padding: 20px;
    }
    .profile > div > .img > label{
        color: #fff;
    }
    .profile > div > .img > h2{
        color: #fff;
    }
    .profile > div > .img > img {
        width: 180px;
        height: 180px;
        position: absolute;
        top: 50%;
        left: 80%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
        object-fit: cover;
    }
    .profile > div > .info {
        background-color: #63b7a4;
        margin-top: 5%;
        width: 100%;
        height: 70%;
        position: relative;
        border-radius: 20px;
        overflow: auto;
        padding: 10px;
    }
    .profile > div > .info > center > h2 {
        color: #fff;
    }
    .profile > div > .info > div {
        padding: 20px;
        display: inline-flex;
        width: 100%;
    }
    .profile > div > .info > div > label {
        width: 30%;
        color: #fff;
        font-weight: bold;
    }
    /deep/ .vue-tel-input {
        background-color: #fff;
        border-radius: 15px;
        border-style: ridge;
        width: 100%;
    }
    /deep/ .vue-tel-input > input {
        height: 40px;
        text-align: center;
        border-radius: 15px;
        margin-left: -57px;
    }

    /deep/ .check-number-modal-header {
        text-align: center;
        padding: 0;
        padding-top: 10px;
        display: block;
    }
    /deep/ .check-number-modal-header > button {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .profile > div > .info > div > input {
        float: right;
        width: 100%;
        height: 40px;
        text-align: center;
        border-radius: 20px;
    }
    .profile > div > .info > div > h5 {
        color: #fff;
    }
    .profile > div > .info > center >button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    .profile > div > .permission {
        background-color: #63b1b7;
        height: 47.5%;
        border-radius: 20px;
        padding: 10px;
    }
    .profile > div > div > center > h2 {
        color: #fff;
        margin: 20px;
    }
    .profile > div > .password {
        margin-top: 5%;
        background-color: #63b763;
        height: 47.5%;
        border-radius: 20px;
        padding: 10px;
        overflow: auto;
    }
    .profile > div > .permission > div{
        width: 100%;
        height: 40%;
        display: flex;
    }
    .profile > div > .permission > div > div{
        width: 100%;
        height: 100%;
        text-align: center;
    }
    .profile > div > .permission > div > div > label {
        width: 100%;
    }
    .profile > div > .permission > div > div > img {
        width: 70px;
    }

    .profile > div > .password > div {
        width: 100%;
        display: grid;
        text-align: center;
        padding: 20px;
    }
    .profile > div > .password > div > label{
        margin-top: -10px;
        font-weight: bold;
        color: #fff;
        font-size: 23px;
    }
    .profile > div > .password > div > input{
        height: 35px;
        text-align: center;
        border-radius: 20px;
    }
    .profile > div > .password >.error-mess {
        color: red;
        font-style: oblique;
    }
    .profile > div > .password > center >button {
        background-color: #e0b059;
        color: #fff;
        width: 150px;
        height: 60px;
        border-radius: 30px;
    }
    input[type=file] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue